import Banner from 'components/Banner';
import Label from 'components/Label';
import NewsSlider from 'components/NewsSlider';
import TextWithIcon from 'components/TextWithIcon';
import articleBanner from 'images/article-banner.jpg';
import image1 from 'images/article-box-image-1.jpg';
import image2 from 'images/article-box-image-2.jpg';
import image3 from 'images/article-box-image-3.jpg';
import image4 from 'images/article-box-image-4.jpg';

const Article = () => (
    <div className="container">
        <Banner image={articleBanner} buttonText="LEARN MORE">
            <Label>article</Label>
            <h2>Friendly seedlings under stressful conditions</h2>
            <div>
                <TextWithIcon iconName="calendar" text={'25.08.2023'} />
                <TextWithIcon iconName="clock" text={'5 min to read'} />
            </div>
        </Banner>

        <article className="article-content">
            <h4>The winter grain sowing campaign will start soon.</h4>
            <p>
                The key to high yields is the use of seeds of the best zoned varieties, high reproductions, germination
                rate of at least 92%, and varietal purity of at least 98%.
            </p>
            <p>Seed treatment is also a mandatory procedure to protect against diseases and soil pests.</p>
            <p>
                However, even with all the highest seed quality indicators and protection conditions, it is not possible
                to achieve friendly germination and high wintering performance of winter cereals.
            </p>
            <hr />
            <h5>
                To achieve high germination energy and seed germination, early and friendly germination under stressful
                conditions, and to increase the viability and immunity of seedlings, a fairly simple technique is to
                treat seeds with microelements simultaneously with seed treatment.
            </h5>
            <p>
                To do this, you should use products specially designed for seed treatment, which have a number of
                requirements: compatibility with disinfectants, the presence of surfactants to evenly cover the seed
                with the working solution, the optimal composition of the necessary nutrients, the presence of a strong
                chelating agent for metal elements.
            </p>
            <blockquote>
                <p>
                    <strong>Wuksal Terios</strong> line is designed to ensure that any crop receives the necessary
                    supply of nutrients at the initial stages of development.
                </p>
                <br />
                <p>
                    <strong>All Wuksal Terios</strong> are ideally combined with fungicidal and insecticidal treatments
                    and enhance their effect. They have excellent coverage and adhesion of nutrients on the seed
                    surface.
                </p>
            </blockquote>
            <div className="box">
                <img src={image4} alt="" />
                <div>
                    <h5>
                        To achieve high germination energy and seed germination, early and friendly germination under
                        stressful conditions, and to increase the viability and immunity of seedlings, a fairly simple
                        technique is to treat seeds with microelements simultaneously with seed treatment.
                    </h5>
                    <ul>
                        <li>
                            <p>
                                <strong>Wuksal Terios Universal</strong> is a complex suspension for the treatment of
                                seed for many crops. The special additives included in the composition ensure uniform
                                distribution of the product and high-quality adhesion to the seed surface.
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>Wuksal Terios Universal</strong> activates physiological and biochemical
                                processes in germinating seeds, increases the energy of seed germination, and increases
                                field germination. The composition of Vuxal Terios Universal is designed to ensure that
                                any crop receives the necessary supply of nutrients at the initial stages of growth.
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>Wuksal Terios Universal</strong> is ideally combined with fungicidal and
                                insecticidal treatments, ensuring their optimal effect.
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="box">
                <img src={image2} alt="" />
                <div>
                    <h5>
                        An innovative biostimulating seed treatment suspension based on the seaweed Ascophyllum nodosum.
                    </h5>
                    <ul>
                        <li>
                            <p>
                                <strong>Wuksal Terios Vita</strong> is a complex suspension for the treatment of seed of
                                all crops.
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>Wuksal Terios Vita</strong> fully provides germinating seeds with the necessary
                                nutrients. The presence of natural phytohormones accelerates seed germination and
                                stimulates seedling growth, as well as improves their viability under adverse
                                conditions. Additional components provide excellent adhesion and uniform distribution on
                                the seed surface.
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>Wuksal Terios Vita</strong> contains natural biologically active ingredients and
                                trace elements, in particular, manganese, iron and zinc. The main biologically active
                                ingredients are cytokinins, gibberellins, auxins, betaines, polysaccharides, alginates,
                                vitamins, etc.
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="box">
                <img src={image3} alt="" />
                <div>
                    <h5>
                        A special highly concentrated suspension for the treatment of seeds of many crops with an
                        additional effect of adhesive and surfactant.
                    </h5>
                    <ul>
                        <li>
                            <p>
                                <strong>Wuxal Terios Zn</strong> is a seed treatment suspension that, in addition to a
                                high zinc content, also contains trace elements such as copper, boron, manganese and
                                molybdenum. The presence of sulfur contributes to the effective absorption and
                                transformation of mineral nitrogen from the soil and improves vegetative growth and
                                development of seedlings.
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>Wuxal Terios Zn</strong> is specially designed to meet the special needs of
                                crops grown on soils with low zinc content.
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>Wuxal Terios Zn</strong> is evenly distributed on the seed surface and has
                                excellent adhesive and surfactant properties. It can be used in combination with seed
                                treatment agents.
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <hr />
            <h5>
                UniferX, together with its partners in Ukraine, announces a <a href="/#">special offer</a>!
            </h5>
            <blockquote>
                In the period from 20.07.2023 to 30.09.2023, purchase Wuksal trademark products for seed treatment
                (Wuksal Terios Vita, Wuksal Terios Universal, Wuksal Terios Zn) with discounts, namely
            </blockquote>
            <div className="box">
                <img src={image1} alt="" />
                <div>
                    <h5>
                        The promotion is valid when purchasing Vuxal exclusively from authorized{' '}
                        <a href="/#">importers and distributors.</a>
                    </h5>
                    <ul>
                        <li>
                            <p>The amount of products is limited!</p>
                        </li>
                        <li>
                            <p>The special offer is valid until 09.30.2023 including.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </article>
        <NewsSlider />
    </div>
);

export default Article;
